import ParseImgs from './ParseImgs';

export default ParseImgs;
